<template>
  <div class="restore-point-properties-tab">
    <mi-infinite-scroll>
      <div class="flex justify-end q-pb-md">
        <mi-btn class="restore-point-properties-tab__editBtn" flat @click="openEditDialog">Edit</mi-btn>
      </div>
      <div class="restore-point-properties-tab__info q-pb-md">
        <div class="restore-point-properties-tab__info-section">
          <h5 class="title__small">Configuration Name</h5>
          <p>{{ configuration.name || '-' }}</p>
        </div>
        <div class="restore-point-properties-tab__info-section">
          <h5 class="title__small">Description</h5>
          <p>{{ configuration.description || '-' }}</p>
        </div>
        <div class="flex row">
          <div class="restore-point-properties-tab__info-section fixed-width">
            <h5 class="title__small">Product Model</h5>
            <p>{{ configuration.productModel?.businessName || '-' }}</p>
          </div>
          <div class="restore-point-properties-tab__info-section">
            <h5 class="title__small">Planning Period</h5>
            <p>{{ configuration.planningPeriodRange?.from || '-' }}</p>
          </div>
        </div>
        <div class="flex row">
          <div class="restore-point-properties-tab__info-section fixed-width">
            <h5 class="title__small">Project</h5>
            <p>{{ configuration.project || '-' }}</p>
          </div>
          <div class="restore-point-properties-tab__info-section">
            <h5 class="title__small">Creator</h5>
            <p>{{ configuration.creator || '-' }}</p>
          </div>
        </div>
      </div>
      <div class="restore-point-properties-tab__info q-pa-md">
        <h5 class="title">
          <img src="@/assets/images/pac/link-img.svg" alt="" />
          Links
        </h5>
        <div class="flex row restore-point-properties-tab__info-small-section">
          <h5 class="title__small">C4S/AE NR</h5>
          <p class="q-pl-sm">{{ configuration.c4sCode || 'N/A' }}</p>
        </div>
        <div class="flex row restore-point-properties-tab__info-small-section">
          <h5 class="title__small">Windchill ID</h5>
          <a
            v-if="configuration?.windChillData?.variantSpecNumber"
            class="q-pl-sm"
            :href="configuration?.windChillData?.windchillURL"
          >
            {{ configuration?.windChillData?.variantSpecNumber }}
          </a>
          <p v-else class="q-pl-sm">-</p>
        </div>
      </div>
      <div class="restore-point-properties-tab__info q-pa-md">
        <h5 class="title">
          <img src="@/assets/images/pac/login-img.svg" alt="" />
          Permission access
        </h5>
        <p class="q-mb-none q-mt-sm">{{ configurationAllowedUsersList() }}</p>
      </div>
    </mi-infinite-scroll>
  </div>
</template>

<script>
  import MiBtn from '../../../../../packages/@mi-library/MiBtn/MiBtn.vue'
  import MiInfiniteScroll from '../../../../../packages/@mi-library/MiInfiniteScroll/MiInfiniteScroll.vue'

  export default {
    name: 'ConfigRestorePointPropertiesTab',
    components: { MiInfiniteScroll, MiBtn },
    props: {
      configuration: {
        type: Object,
        required: true
      },
      openEditDialog: {
        type: Function,
        required: true
      },
      configurationAllowedUsersList: {
        type: Function,
        required: true,
        default: () => {}
      }
    }
  }
</script>

<style lang="scss" scoped>
  .restore-point-properties-tab {
    line-height: 150%;

    &__editBtn {
      font-size: 14px;
    }

    &__info-section {
      padding: 16px 16px 0;

      p {
        margin-top: 4px;
        margin-bottom: 0;
      }
    }

    &__info-small-section {
      padding: 8px 0 0;
      align-items: baseline;

      p {
        margin-bottom: 0;
      }
    }

    .fixed-width {
      width: 204px;
    }

    &__info {
      margin-bottom: 16px;
      background-color: #eaedf366;
      font-size: 14px;

      .title {
        font-weight: 700;
        font-size: 14px;
        gap: 10px;
        display: flex;
        flex-direction: row;
        font-family: $mi-typography-font-family;
        align-items: baseline;

        &__small {
          font-size: 12px;
          line-height: 18px;
        }
      }
    }

    h5 {
      margin: 0;
      font-size: 14px;
    }
  }

  .mi-infinite-scroll {
    overflow: auto;
    height: calc(100vh - 220px);
    overflow-y: scroll;
  }

  .mi-infinite-scroll::-webkit-scrollbar {
    width: .1em;
  }

  .mi-infinite-scroll::-webkit-scrollbar-thumb {
    background-color: #ffffff;
  }
</style>
